module.exports = __webpack_public_path__ + "static/20-10-13_21-37-24_1393-84b79cedc0c1ee13f9a2a3f10a30ac0f.jpg";